<template>
    <div class="reo-invoice" v-if="show">
        <div class="reo-invoice-inner">
            <header>
                <img :src="config.logo" class="invoice-logo">
            </header>
            <main>
                <h1>INVOICE</h1>
                <div class="invoice-content">
                    <div class="shipping-to">
                        <h2>Bill To</h2>
                        <div class="shipping-content">
                            <p>{{ payment.payer.name }}</p>
                            <p>{{ payment.payer.line1 }}, {{ payment.payer.line2 }}</p>
                            <p>{{ payment.payer.city }}, {{ payment.payer.state }}</p>
                            <p>{{ payment.payer.country }}, {{ payment.payer.postalCode }}</p>
                        </div>
                    </div>
                    <div class="invoice-details">
                        <div class="invoice-details-inner">
                            <ul>
                                <li><strong>Payment ID:</strong> #{{ payment.id }}</li>
                                <li><strong>Payment Date:</strong> {{ date( payment.createdAt ) }}</li>
                                <li><strong>Payment Method:</strong> {{ payment.method.platform }}</li>
                            </ul>
                            <ul>
                                <li><strong>Account:</strong> {{ FEATURE('cloud.email_check') ? '+' + $store.state.user.user.mobilePhone.number : $store.state.user.user.email.address }}</li>
                                <li><strong>Cloud Plan:</strong> {{ payment.items[0].name }} ({{ $tc( `cycle.${payment.items[0].details.cycle.standard.interval.unit}`, payment.items[0].details.cycle.standard.interval.frequency, {

                                    count: payment.items[0].details.cycle.standard.interval.frequency

                                }) }})</li>
                                <li><strong>Price:</strong> {{ payment.currency }} {{ payment.amount }}</li>
                                <li><strong>Valid Time:</strong> {{ validDate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import { config } from 'CONFIG';
import { getOrderDetailById } from '@/api/cart';
import { timeResolve } from '@/common/js/date';
export default {
    data () {

        return {

            config,
            id: this.$route.params.id,
            payment: {},
            show: false

        };

    },
    async created () {
        
        if ( this.id ) {

            let payment = await getOrderDetailById( this.id );
            this.payment = payment.data;
            this.show = true;

        }
        
    },
    mounted () {
        
        $( 'body' ).addClass( 'not-show-cookies' );

    },
    destroyed () {
        
        $( 'body' ).removeClass( 'not-show-cookies' );
        
    },
    methods: {

        date ( data ) {

            let {

                monthAbbr,
                dateOfMonth,
                year

            } = timeResolve( data );
            return `${monthAbbr} ${dateOfMonth}, ${year}`;

        }

    },
    computed: {

        validDate () {

            let payment = this.payment;
            if ( payment.items && payment.items[ 0 ].validTime ) {

                let start = timeResolve( payment.items[ 0 ].validTime.from );
                let end = timeResolve( payment.items[ 0 ].validTime.to );
                return `${start.month}/${start.dateOfMonth}/${start.year} - ${end.month}/${end.dateOfMonth}/${end.year}`;

            }
            return '';
            
        }

    }

};
</script>

<style scoped lang="less">
.reo-invoice{
    max-width: 1000px;
    margin: 0 auto;
}
.reo-invoice-inner{
    padding: 0 1.05rem;
    @media @mobile{
        padding: 0;
    }
}
@media @mobile{
    .invoice-logo{
        width: 1.5rem;
    }
}
header{
    height: 0.88rem;
    line-height: 0.88rem;
    @media @mobile{
        padding: 0 15px;
    }
}
main{
    padding-top: 0.6rem;
    font-size: 0.16rem;
    @media @mobile{
        padding-top: 0.6rem;
        font-size: 0.26rem;
    }
}
h1{
    font-size: 0.36rem;
    font-weight: 700;
    margin-bottom: 0.1rem;
    @media @mobile{
        font-size: 0.5rem;
        margin-bottom: 0.6rem;
        padding: 0 15px;
    }
}
.invoice-content{
    @media @pc{
        display: flex;
        align-items: center;
    }
}
h2{
    font-size: 0.22rem;
    font-weight: 700;
    margin-bottom: 0.2rem;
    @media @mobile{
        font-size: 0.32rem;
        font-weight: 500;
        margin-bottom: 0.3rem;
    }
}
.shipping-content{
    padding-left: 0.15rem;
    border-left: 1px solid #ccc;
    margin-right: 0.4rem;
    p{
        font-weight: 500;
    }
    p+p{
        margin-top: 0.2rem;
    }
    @media @mobile{
        border: none;
        padding: 0;
        margin: 0;
    }
    @media @pc{
        min-width: 1.84rem;
    }
}
.shipping-to{
    @media @mobile{
        margin-bottom: 0.6rem;
        padding: 0 15px;
    }
}
.invoice-details-inner{
    display: inline-block;
    text-align: left;
    @media @mobile{
        display: block;
    }
}
.invoice-details{
    padding: 0.6rem 0;
    flex-grow: 1;
    text-align: center;
    border-radius: 0.15rem;
    background-color: #F7F8F9;
    li{
        :before{
            content: '';
            display: inline-block;
            width: 0.05rem;
            height: 0.05rem;
            border-radius: 100%;
            background-color: #333;
            vertical-align: middle;
            margin-right: 0.15rem;
        }
    }
    ul+ul{
        padding-top: 0.2rem;
        margin-top: 0.2rem;
        border-top: 1px solid #ccc;
    }
    li+li{
        margin-top: 0.2rem;
    }
    @media @mobile{
        padding: 0.6rem 15px;
        text-align: left;
        li{
            :before{
                display: none;
            }
            strong{
                display: inline-block;
                width: 3rem;
            }
        }
        li+li{
            margin-top: 0.3rem;
        }
        ul+ul{
            padding-top: 0.6rem;
            margin-top: 0.6rem;
        }
    }
    @media @pc{
        li>strong{
            font-size: 0.18rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/paymentHistory/invoice.vue